var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", [
          _c("label", { attrs: { for: "" } }, [_vm._v("Период")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex" },
            [
              _c("date-range-picker", {
                ref: "picker",
                staticClass: "mr-2",
                attrs: {
                  opens: "right",
                  ranges: _vm.ranges,
                  "locale-data": _vm.date_locale,
                },
                on: { update: _vm.updateSelectDates },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function (picker) {
                      return [
                        _vm._v("\n              Выбрать даты\n            "),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.dateRange,
                  callback: function ($$v) {
                    _vm.dateRange = $$v
                  },
                  expression: "dateRange",
                },
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("MaskedInput", {
                      staticClass: "form-control",
                      attrs: { mask: _vm.mask, keepCharPositions: true },
                      on: { change: _vm.updateDates },
                      model: {
                        value: _vm.userDate.start,
                        callback: function ($$v) {
                          _vm.$set(_vm.userDate, "start", $$v)
                        },
                        expression: "userDate.start",
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _c("MaskedInput", {
                      staticClass: "form-control",
                      attrs: { mask: _vm.mask, keepCharPositions: true },
                      on: { change: _vm.updateDates },
                      model: {
                        value: _vm.userDate.end,
                        callback: function ($$v) {
                          _vm.$set(_vm.userDate, "end", $$v)
                        },
                        expression: "userDate.end",
                      },
                    }),
                    _vm._v(" "),
                    _c("LoadingButton", {
                      attrs: {
                        title: "Показать",
                        loading: _vm.loading,
                        color: _vm.$constants.SUCCESS_COLOR,
                        onClick: () => _vm.getRecords(),
                        className: "btn btn-outline-success",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex justify-content-between mt-2" }, [
          _c(
            "div",
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Учитывать страны закупки"),
              ]),
              _vm._v(" "),
              _c("multiselect", {
                attrs: {
                  options: _vm.$AllCountries,
                  "track-by": "name",
                  label: "name",
                  "show-labels": false,
                  placeholder: "Выберите страны",
                  multiple: true,
                },
                model: {
                  value: _vm.includedCountries,
                  callback: function ($$v) {
                    _vm.includedCountries = $$v
                  },
                  expression: "includedCountries",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Исключить страны закупки"),
              ]),
              _vm._v(" "),
              _c("multiselect", {
                attrs: {
                  options: _vm.$AllCountries,
                  "track-by": "name",
                  label: "name",
                  "show-labels": false,
                  placeholder: "Выберите страны",
                  multiple: true,
                },
                model: {
                  value: _vm.excludedCountries,
                  callback: function ($$v) {
                    _vm.excludedCountries = $$v
                  },
                  expression: "excludedCountries",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 3,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _vm.records
            ? [
                _c(
                  "div",
                  { staticClass: "mb-1" },
                  [
                    _c("p", { staticClass: "mb-1" }, [
                      _vm._v("Всего - упаковок: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            Object.values(_vm.countriesSum).reduce(
                              (acc, c) => acc + c,
                              0
                            )
                          )
                        ),
                      ]),
                      _vm._v(" препаратов: "),
                      _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.sortedCountries, function (country) {
                      return _vm.countriesSum[country.id]
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(country.name) +
                                ":\n            "
                            ),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.countriesSum[country.id])),
                            ]),
                          ])
                        : _vm._e()
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("table", { staticClass: "table table-sm table-hover" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.records, function (record, i) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              i +
                                1 +
                                (_vm.currentPage - 1) * _vm.paginator.per_page
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(record.title))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(record.total))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            _vm._s(Math.round(_vm.inStore[record.drug_id] || 0))
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 3,
                            "margin-pages": 2,
                            "click-handler": _vm.getRecords,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("по")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Упаковки")]),
        _vm._v(" "),
        _c("th", [_vm._v("Склад")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }